import React, { useEffect } from 'react';
import { Link, Head, useForm } from '@inertiajs/inertia-react';
import logo from '../../images/logo.png';
import Input from '@/Components/Input';
import Label from '@/Components/Label';
import Button from '@/Components/Button';
import Radio from '@/Components/Radio';
import ApplicationLogo from '@/Components/ApplicationLogo';
import { DateTime } from 'luxon';
import Cookies from 'js-cookie';

export default function Search({
    store,
    quantity,
    date,
    availability,
    office,
    scheduleType,
    uuid,
    hasQuotaForClasses,
    ...props
}) {
    const { data, setData, processing, errors, get } = useForm({
        schedule: null,
        quantity,
        date,
        uuid
    });

    const onHandleChange = (event) => {
        console.log('Change', event.target.name, event.target.value);
        setData(event.target.name, event.target.value);
    };

    const submit = (e) => {
        e.preventDefault();
        // if (parseInt(quantity) === 1) {
        //     window.sessionStorage.removeItem('order-users-registration');
        //     return get(route('order.create', {office: office.slug, scheduleType: scheduleType}))
        // }

        if ((scheduleType.type === 'skating_class' || scheduleType.type === 'skating_class_monthly') && !hasQuotaForClasses) {
            return;
        }

        return get(route('schedule.users-registration', {office: office.slug, scheduleType: scheduleType, uuid}))
    }

    useEffect(() => {
        Cookies.remove('order_checkout_clients');
    }, [])

    return (
        <>
            <Head title="Selección de hora - Cerogrado" />
            <div className="relative flex items-top justify-center min-h-screen bg-gray-100 sm:items-center sm:pt-0">

                <div className="max-w-6xl mx-2 sm:mx-auto sm:px-6 lg:px-8 py-4">

                    <div className="flex justify-center pt-8 sm:pt-0">
                        {/* <img src={logo} className="h-16 w-auto sm:h-20"/> */}
                        <ApplicationLogo store={store} />
                    </div>

                    {
                        scheduleType.type === 'skating_class' || scheduleType.type === 'skating_class_monthly' ? (
                            <>
                                <div className="w-full sm:max-w-md mt-6 px-6 py-4 bg-white shadow-md overflow-hidden sm:rounded-lg">
                                    <h1 className='mb-4 text-center text-gray-900 text-lg font-bold'>Compra de tickets</h1>
                                    <p className='text-center'>{props.queryDescription}</p>
                                    <Link
                                        href={route('service.quantity-date-selector', {office: office.slug, uuid})}
                                        as="button"
                                        type="button"
                                        className='flex items-center px-2 py-1 border border-gray-900 rounded-md font-semibold text-xs text-gray-900 hover:bg-gray-900 hover:text-white transition ease-in-out duration-150 mx-auto mt-3'
                                        data={{ quantity, date }}>
                                        Modificar
                                    </Link>

                                    {!hasQuotaForClasses && (
                                        <div className='text-center text-xl font-bold mt-8 text-gray-700'>
                                            Lo sentimos, pero no quedan cupos de clases {scheduleType.type === 'skating_class' ? 'diarias' : 'mensuales'} disponibles.<br/>
                                        </div>
                                    )}

                                    <form onSubmit={submit}>
                                        <div className="flex items-center justify-center mt-8">
                                            <Button processing={processing || !hasQuotaForClasses}>
                                                Continuar
                                            </Button>
                                        </div>
                                    </form>

                                </div>
                            </>
                        ) : (
                            <>
                                <div className="w-full sm:max-w-md mt-6 px-6 py-4 bg-white shadow-md overflow-hidden sm:rounded-lg">
            
                                    <h1 className='mb-4 text-center text-gray-900 text-lg font-bold'>Compra de tickets</h1>
                                    <p className='text-center'>{props.queryDescription}</p>
                                    <Link
                                        href={route('service.quantity-date-selector', {office: office.slug, uuid, type: scheduleType.type})}
                                        as="button"
                                        type="button"
                                        className='flex items-center px-2 py-1 border border-gray-900 rounded-md font-semibold text-xs text-gray-900 hover:bg-gray-900 hover:text-white transition ease-in-out duration-150 mx-auto mt-3'
                                        data={{ quantity, date: date }}>
                                        Modificar
                                    </Link>
                                </div>
                                {
                                    availability.length
                                    ? <div className="w-full sm:max-w-md mt-6 px-6 py-4 bg-white shadow-md overflow-hidden sm:rounded-lg">
                                        <form onSubmit={submit}>
                                            <h2 className='mb-4 text-center text-gray-900 text-lg font-bold'>Opciones disponibles</h2>
                                            {
                                                availability.map(i =>
                                                    <Radio
                                                    key={i.id}
                                                    value={i.id}
                                                    binding={data.schedule}
                                                    name='schedule'
                                                    handleChange={onHandleChange}>
                                                        {/* <time dateTime={i.startTime}>{i.formatedTime} hrs.</time> */}
                                                        {/* <time className='ml-2 text-gray-500 text-sm' dateTime={`PT${i.duration}M`}>
                                                            ({i.duration} mins.)
                                                        </time> */}
                                                        <time dateTime={i.startTime}>{DateTime.fromSQL(i.startTime).toFormat('HH:mm')} a {DateTime.fromSQL(i.startTime).plus({ hours: scheduleType.duration }).toFormat('HH:mm')} hrs.</time>
                                                    </Radio>
                                                )
                                            }
                                            <div className="flex items-center justify-center mt-8">
                                                <Button  processing={processing || !data.schedule}>
                                                    Continuar
                                                </Button>
                                            </div>
                                        </form>
                                    </div>
                                    : <div className='text-center text-xl font-bold mt-8 text-gray-700'>
                                        Lo sentimos, pero no hay opciones disponibles.<br/>
                                        Presiona modificar para intentarlo nuevamente.
                                    </div>
                                }
                            </>
                        )
                    }


                </div>

            </div>
        </>
    );
}
